export default __webpack_public_path__ + "static/media/lean-startup-for-corporates.df1469b9.svg";